import script from "./CustomerProductMsku.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerProductMsku.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerProductMsku.vue?vue&type=style&index=0&id=26143da6&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26143da6"]])

export default __exports__